import React from 'react'
import Help from './Help'

const HelpPage = () => {
  return (
    <div style={{ paddingTop : '10vw'}}><Help/></div>
  )
}

export default HelpPage